export default "__VITE_ASSET__ae41626d__"